//  This removes the initiate res object
import actions from '@ehi/global-marketing-interface/lib/actions';

export const removeInitiateResObject = () => (dispatch) =>
  dispatch(actions.reservations.cleanNonSessionReservationState({ opts: { cleanInitiateState: true } }));
